// Shared CSS design tokens (spring easing curves, @keyframes, placement
// variables) that .module.css files reference via var(). These tokens must be
// available globally so that any CSS module can use them without its own
// @import — which is important because Metro's lightningcss scopes @keyframes
// names inside .module.css files, breaking the link between a module's
// `animation:` and a keyframe defined in a different file.
//
// We use a JS import here instead of a CSS @import inside global.css because
// Metro does not inline CSS @import — it records the dependency but never
// bundles the imported file, so the rules never reach the page.
import 'component/ui/tokens.css';
// this file allow font scaling inside webviews
import './css/global.css';
